<!-- <template>
    <div class="vx-row match-height">
      
      <div class="vx-col w-full">
        <vx-card class="mt-2">
          <vs-tabs vs-alignment="fixed" alignment="fixed">
            <vs-tab :label="$t('PreInvoiceWaitingForInvoice')">
              <draft></draft>
            </vs-tab>
            <vs-tab :label="$t('PreInvoiceWaitingForProcess')">
              <proccessing></proccessing>
            </vs-tab>
            <vs-tab :label="$t('InvoiceWaitingForConfirm')">
              <ReviewQueue></ReviewQueue>
            </vs-tab>
            <vs-tab :label="$t('Confirmed')">
              <confirm></confirm>
            </vs-tab>

            <vs-tab :label="$t('Delivered')">
              <delivered></delivered>
            </vs-tab>

          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </template>
  <script>
  import confirm from "../Invoice/Confirm.vue"
  import draft from "../Invoice/DraftInvoice.vue"
  import ReviewQueue from "./ReviewQueue.vue";
  import proccessing from "../Invoice/Processing.vue"
  import sent from "../Invoice/Sent.vue"
  import delivered from "../Invoice/Delivered.vue"
  import allPreInvoice from "../Invoice/AllInvoice.vue"
  export default {
    components: {
      draft,
      confirm,
      ReviewQueue,
      proccessing,
      sent,
      delivered,
      allPreInvoice
    },
  };
  </script> -->
  <template>
    <div class="vx-card">
      <div class="vx-card__body card-body">

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('RequesterName'), sort: 'RequesterName' },
                { title: $t('Departman'), sort: 'Departman' },
                { title: $t('DeliveryDate'), sort: 'DeliveryDate' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.requesterInfo ? row.requesterInfo.name : "-" }}
                </td>
                <td>
                  {{ row.departmentUnit ? row.departmentUnit.name : "-" }}
                </td>
                <td>
                  {{ row.persianDeliveryClock ? row.persianDeliveryClock : "-" }}
                </td>
  
                <td>
                  <router-link
                  v-has-permission="permission1"
                  :to="'/ProcurementManagement/Invoice/Details' + '/'+ row.id"
                    >
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-eye"
                        class="d-inline"
                      ></vs-button>
                    </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import DataGrid from "@/components/datagrid/DataGrid";
  
  export default {
    components: {
      DataGrid,
    },
    data() {
      return {
        permission1:"GotoConfirmInvoice|GetInvoiceById",
        gridDataSource: {
          type: "app",
          service: "Procurements/api/InvoicesQuery?invoiceState=1&",
        },
        gridSearchData: {},
      };
    },
    methods: {
      editPurchaseRequest(model) {},
      deletePurchaseRequest(id) {},
    },
  };
  </script>
  